import { useState, useEffect } from 'react'
import configs from '../../config'
import Cookies from 'js-cookie'

const OrderDetailInvoice = ({ order }) => {
  const [invoiceNo, setInvoiceNo] = useState([])

  const fetchInvoiceNo = async () => {
    try {
      const requestUrl = `${configs.apiAdminGateway}/api/v1/admin/invoice/${order.orderNo}`
      const getAccessToken = Cookies.get('accessToken')
      const myHeaders = new Headers()
      myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
      myHeaders.append('Content-Type', 'application/json')
      const response = await fetch(requestUrl, { method: 'GET', headers: myHeaders })
      const toJson = await response.json()
      if (toJson?.status?.code === 0) {
        setInvoiceNo([...toJson.data])
      } else {
        setInvoiceNo([])
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchInvoiceNo()
  }, [order.orderNo])

  return (
    <div
      className="d-flex flex-row"
      style={{
        gap: '8px',
      }}
    >
      {invoiceNo.length > 0 &&
        invoiceNo.map((invoice) => (
          <span
            style={{
              fontSize: '20px',
              fontWeight: '500',
              color: '#000',
            }}
            key={invoice.invoiceNo}
          >
            {invoice.invoiceNo}
          </span>
        ))}
    </div>
  )
}

export default OrderDetailInvoice
